module.exports = __webpack_public_path__ + "static/logo-7e381e5f522f10da030e4957f87fe365.png";